(function(window, playerViewDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.playerView = playerViewDefinition(window,
      window.jQuery,
      namespace.externalMessageController,
      namespace.deviceInfo,
      namespace.performanceWrapper,
      namespace.IoOverlayView,
      namespace.localizationStrings,
      namespace.templates,
      namespace.quizController,
      namespace.playerConfiguration,
      namespace.PlayerSettingsView,
      namespace.videoAnalytics,
      namespace.xmp,
      namespace.questionGrader,
      namespace.fathomService,
      namespace.youTube,
      namespace.iOSTextInputFix,
      namespace.RenderLibView,
      namespace.TocView,
      namespace.AudioDescriptionControlView,
      namespace.AudioDescriptionTrackView,
      namespace.CaptionsView,
      namespace.HotspotsView,
      namespace.VolumeControlView,
      namespace.PlayRewindControlsView,
      namespace.PrevNextControlsView,
      namespace.PipControlView,
      namespace.FullscreenControlView,
      namespace.ClickControlsView,
      namespace.cssClasses,
      namespace.events,
      namespace.responsiveController,
      namespace.ProgressBarControlView,
      namespace.BeforeAfterPlayControlsView,
      namespace.tabIndex,
      namespace.highlightDisabler,
      namespace.mediaType,
      namespace.urlService,
      namespace.viewHelper,
      namespace.ieFullscreenDimensionsFix,
      namespace.reportType,
      namespace.log,
      namespace.supportedPluginViewElements,
      namespace.scormController,
      namespace.endActionType,
      namespace.endActionsController,
      namespace.messageBarType,
      namespace.MessageBarView,
      namespace.TabController);
})(this, function(window,
                  $,
                  externalMessageController,
                  deviceInfo,
                  performanceWrapper,
                  IoOverlayView,
                  localizationStrings,
                  templates,
                  quizController,
                  playerConfiguration,
                  PlayerSettingsView,
                  videoAnalytics,
                  xmp,
                  questionGrader,
                  fathomService,
                  youTube,
                  iOSTextInputFix,
                  RenderLibView,
                  TocView,
                  AudioDescriptionControlView,
                  AudioDescriptionTrackView,
                  CaptionsView,
                  HotspotsView,
                  VolumeControlView,
                  PlayRewindControlsView,
                  PrevNextControlsView,
                  PipControlView,
                  FullscreenControlView,
                  ClickControlsView,
                  cssClasses,
                  events,
                  responsiveController,
                  ProgressBarControlView,
                  BeforeAfterPlayControlsView,
                  tabIndex,
                  highlightDisabler,
                  mediaType,
                  urlService,
                  viewHelper,
                  ieFullscreenDimensionsFix,
                  reportType,
                  log,
                  supportedPluginViewElements,
                  scormController,
                  endActionType,
                  endActionsController,
                  messageBarType,
                  MessageBarView,
                  TabController) {
   'use strict';

   var _self = this;
   var _$container = null;
   var _containerSelector = null;
   var _containerIDString = null;
   var _videoTagUniqueId = null;

   var _html5ViewEnabled = false;
   var _mediaList = null;
   var _playerViewEventCallbacks = {};
   var _queuedMediaBinds = {};
   var _initializedValues = {};
   var _captionService = null;

   var _mediaWrapper = null;
   var _mediaElement = null;
   var _$videoWrapper = null;
   var _$videoDiv = null;
   var _$controls = null;
   var _$hotspotsContainer = null;
   var _$mediaPluginContainer = null;
   var _$youtubePointerEventWorkaround = null;

   var _renderLibView = null;
   var _tocView = null;
   var _audioDescriptionControlView = null;
   var _audioDescriptionTrackView = null;
   var _captionsView = null;
   var _hotspotsView = null;
   var _beforeAfterPlayControlsView = null;
   var _playRewindControlsView = null;
   var _prevNextControlsView = null;
   var _progressBarControlView = null;
   var _volumeControlView = null;
   var _playerSettingsView = null;
   var _pipControlView = null;
   var _fullscreenControlView = null;
   var _ioOverlayView = null;
   var _clickControls = null;

   var _animationSpeed = 300;
   var _intrinsicWidth = -1;
   var _intrinsicHeight = -1;
   var _currentTime = 0;
   var _currentTimeInMilliseconds = 0;
   var _timeAfterSeek = -1;
   var _updateBufferedTimeout;
   var _lastClickTime;
   var _surfaceClickLeaveDelay = 100;
   var _mouseMoveTolerance = 5;
   var _lastMouseMoveCoords = {
      x: 0,
      y: 0
   };

   var _tabController = null;
   var _xmp = null;
   var _autoHideTimeoutId = -1;
   var _autoHideControllerTime = 5000;
   var _lastQuestionSetId = -1;
   var _lastQuestionSetMarkerTime = -1;
   var _eventLastPercentReported = 0;
   var _eventPercentWatchInc = 10;
   var _canPlayVideo = false;
   var _viewDirty = false;
   var _seeking = false;
   var _displayToc = false;
   var _controlsHidden = false;
   var _videoMetadataReady = false;
   var _processingEndOfVideo = false;
   var _atVideoEndTime = false;
   var _eventPlayTracking = true;
   var _eventCategory = 'HTML5-Video';
   var _haveYouTubePlayer = false;
   var _loadVideoTimeout = 10000;
   var _overlaysDisabled = false;
   var _startPlaybackOnInit = true;
   var _mediaFailedToPlay = false;
   var _autoHideControlsEnabled = false;
   var _playerInitializedAfterMetadataLoaded = false;

   var _lang = localizationStrings;
   var _uiInitialized = false;

   var _controlBarHeight = 48;

   var processPlayerEvent = function(action, label, value) {
      if (playerConfiguration.getCustomEventTracking()) {
         if (playerConfiguration.getCustomEventCallback()) {
            if (playerConfiguration.getAltEventCategoryAsFilename()) {
               playerConfiguration.getCustomEventCallback().call(this, {category: playerConfiguration.getMediaFileName(), action: action, label: label, value: value});
            } else {
               playerConfiguration.getCustomEventCallback().call(this, {category: _eventCategory, action: action, label: label, value: value});
            }
         }
      }

      if (playerConfiguration.getGoogleAnalyticsID()) {
         window._gaq.push(['_trackEvent', _eventCategory, action, label]);
      }
   };

   var onPlayPromiseError = function() {
      // Assume user interaction is needed to play
      _mediaFailedToPlay = true;
      disableAutoHideControls();
      hideControls(true, true);
      _beforeAfterPlayControlsView.videoElementHasLoaded = true;
      _beforeAfterPlayControlsView.showVideoClickToPlayLink();
   };

   var play = function() {
      var playPromise = _mediaElement.play();
      if (playPromise !== undefined) {
         playPromise.catch(onPlayPromiseError);
      }
   };

   var pause = function() {
      _mediaElement.pause();
   };

   var enableControls = function() {
      if (!isControlsHidden()) {
         _$container.trigger(events.Controls.Enable);
      }
   };

   var disableControls = function() {
      _$container.trigger(events.Controls.Disable);
   };

   var sizeCaptions = function() {
      if (_mediaWrapper === undefined || _intrinsicHeight <= 0) {
         return;
      }

      // size video div around captions if caption position is under
      if (_captionService.position === 'under') {
         var newHeight = _intrinsicHeight * ((_$videoWrapper.height() - _$controls.height()) / (_intrinsicHeight + parseFloat(_captionService.height)));
         _$videoDiv.height(newHeight);
      }
      _captionsView.scale = calculateCanvasScale();
   };

   var updateQuizPointAtPosition = function() {
      var playerXOffset = _$container.offset().left;
      var markerXPosition = _progressBarControlView.getXPositionForQuestionSetMarker(_lastQuestionSetId);
      var pointAtXPosition = markerXPosition - playerXOffset;
      quizController.pointViewAt(pointAtXPosition);
   };

   var sizePageElements = function() {
      responsiveController.manageResponsiveClasses();

      var isVideoFoundOnPage = _mediaWrapper && _mediaElement;
      if (isVideoFoundOnPage && _mediaElement.duration) {
         if (quizController.hasQuiz && quizController.quizEnabled) {
            _progressBarControlView.updateQuizMarkers();
            // update bubble position if quizzing is on and there is a view open
            if (quizController.viewIsOpen) {
               updateQuizPointAtPosition();
            }
         }
      }

      if (_tocView && _tocView.isOpen) {
         _tocView.resize();
      }

      sizeCaptions();

      if (_hotspotsView && _mediaWrapper !== undefined) {
         _hotspotsView.size(calculateCanvasScale(), _$videoDiv.width(), _$videoDiv.height());
      }
   };

   var calculateCanvasScale = function() {
      var scale = 1;
      if (_mediaWrapper !== undefined && _intrinsicWidth > 0 && _mediaWrapper.width() > 0) {
         var ratioOfWidth = _mediaWrapper.width() / _intrinsicWidth;
         var ratioOfHeight = _mediaWrapper.height() / _intrinsicHeight;
         scale = Math.min(ratioOfWidth, ratioOfHeight);
      }

      return scale;
   };

   var isControlsHidden = function() {
      return playerConfiguration.getDisableControls() || playerConfiguration.getDisableInteractions();
   };

   var handleControlsUpdated = function() {
      if (isControlsHidden()) {
         hideControls(true, true);
      } else {
         showControlsWithAutoHide();
      }

      //Toggle back and forth to avoid event handler leaking
      disableAutoHideControls();
      enableAutoHideControls();
   };

   var onVideoReady = function() {
      if (isControlsHidden()) {
         disableControls();
      } else {
         _$controls.show();
      }

      _playRewindControlsView.setInitialFocus();

      // setup how controller can be hidden / shown
      enableAutoHideControls();
      _ioOverlayView.hideView();

      _playerViewEventCallbacks[events.External.MediaReady].forEach(function(callback) {
         callback.call(_self);
      });

      _$container.on(events.Controls.Updated, handleControlsUpdated);
   };

   var onExpandVideo = function() {
      pause();
   };

   var onFullScreenChange = function() {
      if (!_fullscreenControlView.isFullScreen) {
         _viewDirty = true;
      }
      _playerViewEventCallbacks[events.External.PlayerFullScreenModeChanged].forEach(function(callback) {
         callback.call(_self);
      });
      sizePageElements();
   };

   var onPipChanged = function(event, eventData) {
      if (_processingEndOfVideo && endActionsController.getEndActionType() !== endActionType.hideReplayControls) {
         return;
      }

      if (!_controlsHidden && eventData.hideControls) {
         hideControls(true, true);
         disableAutoHideControls();
      } else if (_controlsHidden && !eventData.hideControls) {
         showControls(true);
         enableAutoHideControls();
      }
   };

   var finishInitializationAfterMetaDataLoaded = function() {
      _playerInitializedAfterMetadataLoaded = true;

      // scorm production does not support expand video into new window option
      var canSupportExpandVideoMode = !playerConfiguration.isScormLesson && !playerConfiguration.getReportScormComplete() && (_xmp === null || _xmp.quizReportMethod !== reportType.SCORM && _xmp.quizReportMethod !== reportType.APIANDSCORM);

      _fullscreenControlView.initializeFullScreenSupport(canSupportExpandVideoMode);

      // switching between video with picture-in-picture mode does not currently work.
      if (!_mediaList.isPlaylist) {
         _pipControlView.initialize();
      }

      _$container.on(events.Controls.ExpandVideo, onExpandVideo);
      _$container.on(events.Controls.FullScreenChange, onFullScreenChange);
      _$container.on(events.Controls.PipChanged, onPipChanged);

      if (_hotspotsView) {
         _$container.on(events.Controls.HotspotClicked, processHotspotClick);

         _mediaWrapper.on('ratechange', function() {
            _hotspotsView.update(_currentTime);
         }, false);
         _mediaWrapper.on('play', function() {
            _hotspotsView.update(_currentTime);
         }, false);
      }
   };

   var onLoadedMetadata = function() {
      _videoMetadataReady = true;
      _intrinsicWidth = _mediaElement.videoWidth;
      _intrinsicHeight = _mediaElement.videoHeight;
      _currentTime = 0;

      // check to see if quiz exists and it is ready to rumble
      if (_haveYouTubePlayer) {
         onVideoReady();
      } else if (!quizController.hasQuiz || quizController.hasQuiz && (!quizController.quizEnabled || quizController.quizReady)) {
         onVideoReady();
      } else { // update overlay with status of quiz code
         pause();
         _ioOverlayView.displayMessage(quizController.getLastStatusMessage());
      }

      if (videoAnalytics.isEnabled() && !videoAnalytics.isPercentWatchedInitialized()) {
         videoAnalytics.initPercentWatched(_mediaElement.duration * 1000);
      }

      performanceWrapper.createMeasure(events.Timing.VideoMetadataLoaded, events.Timing.VideoMetadataLoaded);
      triggerRumDataEvent([events.Timing.VideoMetadataLoaded]);

      // hotspots
      if (_hotspotsView) {
         var currentFile = _mediaList.isPlaylist ? _mediaList.currentMedia.media : undefined;
         _hotspotsView.init(_intrinsicWidth, _intrinsicHeight, currentFile);
      }

      if (!_playerInitializedAfterMetadataLoaded) {
         finishInitializationAfterMetaDataLoaded();
      }

      _viewDirty = true;
      sizePageElements();
   };

   var onVideoTimeUpdate = function() {
      // ignore time if quiz exists, but not ready, check for duration equal zero to fix issue seen on some Android devices
      if (!_canPlayVideo || _mediaElement.duration === 0 || quizController.hasQuiz && quizController.quizEnabled && !quizController.quizReady) {
         return;
      }

      if (_mediaElement) {
         _currentTime = _mediaElement.currentTime > _mediaElement.duration ? _mediaElement.duration : _mediaElement.currentTime;
      } else {
         _currentTime = 0;
      }

      if (isNaN(_currentTime)) {
         log.logMessage('Player view: Current time is now NaN (_mediaElement.currentTime=' + _mediaElement.currentTime + ', _mediaElement.duration=' + _mediaElement.duration + ')');
      }

      _atVideoEndTime = Number(_mediaElement.currentTime.toFixed(2)) >= Number(_mediaElement.duration.toFixed(2));

      _currentTimeInMilliseconds = _currentTime * 1000;

      // video analytics
      if (videoAnalytics.isEnabled()) {
         updateAnalytics();
      }

      // check for question set
      if (!getScrubbing() && quizController.hasQuiz && quizController.quizEnabled) {
         updateQuizzing();
      }

      if (_hotspotsView) {
         _hotspotsView.update(_currentTimeInMilliseconds);
      }
      updateCaptions();

      // check to see if video is at the end
      if (!getScrubbing() && _lastQuestionSetId === -1 && _atVideoEndTime && !_processingEndOfVideo) {
         processEndOfMedia();
      }
   };

   var updateCaptions = function() {
      var currentFile = _mediaList.isPlaylist ? _mediaList.currentMedia.media : null;
      _captionsView.updateCaption(_currentTimeInMilliseconds, currentFile);
   };

   var updateQuizzing = function() {
      var qs = quizController.findQuestionSet(_currentTimeInMilliseconds);

      if (qs.id < 0) {
         _lastQuestionSetId = -1;
         return;
      }

      if (_lastQuestionSetId !== qs.id) {
         viewHelper.saveActiveElement();
         // make sure control bar is shown up and auto hide is disabled.
         disableControls();
         disableAutoHideControls();
         showControlsWithoutAutoHide();

         if (_tocView && _tocView.isOpen) {
            _tocView.hide(_animationSpeed);
         }

         _lastQuestionSetId = qs.id;
         _lastQuestionSetMarkerTime = qs.markerTime / 1000;
         pause();

         _$container.trigger(events.Quizzing.Paused);

         setTimeout(function() {
            seek(_lastQuestionSetMarkerTime);  // convert back to seconds
         }, 100);

         quizController.displayConfirm(qs.id);

         updateQuizPointAtPosition();

         if (videoAnalytics.isEnabled()) {
            if (!isNaN(qs.markerTime) && videoAnalytics.isPercentWatchedInitialized()) {
               videoAnalytics.markTimeWatched(qs.markerTime);
            } else {
               log.logMessage('Player-view: videoAnalytics percent watched not initialized, or Quiz Marker time is NaN (' + qs.markerTime + ')');
            }

            var percentWatched = videoAnalytics.getPercentageWatchedForVideoSegment(quizController.findPrevMarkerTimeForMarker(qs.id), qs.markerTime);
            quizController.updatePercentWatchedForQuestionSet(_lastQuestionSetId, percentWatched);
         }
      }
   };

   var updateAnalytics = function() {
      if (!_mediaElement.duration) {
         return;
      }

      if (!videoAnalytics.isPercentWatchedInitialized()) {
         videoAnalytics.initPercentWatched(_mediaElement.duration * 1000);
      }

      var percentWatched = Math.round(videoAnalytics.getPercentageWatched() * 100);

      if (!isNaN(_currentTimeInMilliseconds)) {
         videoAnalytics.markTimeWatched(_currentTimeInMilliseconds);
      } else {
         log.logMessage('Player-view: currentTime is NaN (' + _currentTime + ', ' + _currentTimeInMilliseconds + ')');
      }

      // Built in Scorm support
      if (scormController.initialized) {
         scormController.submitVideoWatchedPercentage(0.01 * percentWatched, videoAnalytics.getCurrentPlayTime());
      // Legacy Scorm support
      } else if (typeof window.onVideoWatchedPercentage === 'function') {
         window.onVideoWatchedPercentage(0.01 * percentWatched, videoAnalytics.getCurrentPlayTime());
      }

      if (playerConfiguration.getTrackEvents()) {
         if (percentWatched >= _eventLastPercentReported + _eventPercentWatchInc) {
            _eventLastPercentReported += _eventPercentWatchInc;

            if (_eventLastPercentReported < percentWatched) {
               _eventLastPercentReported = _eventPercentWatchInc * Math.floor(percentWatched / _eventPercentWatchInc) + _eventPercentWatchInc;
            }

            if (_eventLastPercentReported > 100) {
               _eventLastPercentReported = 100;
            }

            processPlayerEvent('Video_Percent_Viewed', 'Viewed: ' + _eventLastPercentReported + ' Percent');
         }
      }
   };

   var showToc = function(bShow) {
      if (bShow) {
         _tocView.open();
         _tocView.resize();
      } else {
         _tocView.close();
      }
   };

   var setupProgressBarAtPageLoad = function() {
      // this is a workaround because the ipad/iphone do not support the
      // progress event so we must check the buffering every second
      _mediaWrapper.on('durationchange', function() {
         updateBuffered();

         if (_updateBufferedTimeout) {
            window.clearInterval(_updateBufferedTimeout);
         }

         _updateBufferedTimeout = window.setInterval(updateBuffered, 1000);
      });
   };

   var updateBuffered = function() {
      var downloaded;
      if (_mediaWrapper && _mediaElement) {
         if (_mediaElement.buffered && _mediaElement.buffered.length) {
            downloaded = Math.min(100, Math.ceil(_mediaElement.buffered.end(_mediaElement.buffered.length - 1) * 100 / _mediaElement.duration));
         }

         _progressBarControlView.updateLoadProgress((downloaded || 0) + '%');

         if (downloaded === 100 && _updateBufferedTimeout) {
            window.clearInterval(_updateBufferedTimeout);
         }
      }
   };

   var getScrubbing = function() {
      return _progressBarControlView ? _progressBarControlView.scrubbing : false;
   };

   var setScrubbing = function(value) {
      _progressBarControlView.scrubbing = value;
   };

   var blockTextSelection = function() {
      document.body.focus();
      document.onselectstart = function() {
         return false;
      };
   };

   var unblockTextSelection = function() {
      document.onselectstart = function() {
         return true;
      };
   };

   var processEndOfMedia = function() {
      if (!_processingEndOfVideo) {
         _processingEndOfVideo = true;
         _progressBarControlView.updateQuizMarkers();
         pause();
         onVideoEnd();
      }
   };

   var seek = function(time) {
      if (_seeking) {
         _timeAfterSeek = time;
         return;
      }

      if (_mediaElement.currentTime.toFixed(4) === time.toFixed(4)) {
         return;
      }

      if (_hotspotsView) {
         _hotspotsView.resetHasPaused();
         _hotspotsView.update(time * 1000);
      }

      if (!getScrubbing() && time === _mediaElement.duration) {
         processEndOfMedia();
      } else {
         _mediaElement.currentTime = time;
      }
   };

   // seek with quizzing stops considered
   var safeSeek = function(time) {
      if (!_mediaWrapper || !_mediaElement) {
         playerConfiguration.setJumpToTime(time);
      }

      seek(_progressBarControlView.getSafeSeekTime(time));
   };

   var hideVideoAndShowClickToReplay = function() {
      if (_tocView && _tocView.isOpen) {
         _tocView.hide(_animationSpeed);
      }

      hideControls(true, true);
      _beforeAfterPlayControlsView.showVideoClickToReplayLink();
   };

   var reshowVideoAfterClickToReplay = function(time, playAfterSeek) {
      _processingEndOfVideo = false;
      _beforeAfterPlayControlsView.hideVideoClickToReplayLink();
      _$videoWrapper.css('visibility', 'visible');

      enableControls();

      if (!_mediaList.isPlaylist) {
         seek(time);
      }

      if (playAfterSeek) {
         if (_mediaList.isPlaylist) {
            _mediaList.currentMediaIndex = 0;
            initCurrentMedia();
         } else {
            play();
         }
      }

      if (_tocView && _tocView.isOpen && !_controlsHidden) {
         _tocView.show(_animationSpeed);
      }

      if (!enableAutoHideControls()) {
         _viewDirty = true;
         showControlsWithAutoHide();
      }
   };

   var showReplayControlsHandler = function() {
      _fullscreenControlView.onVideoEnd();

      disableAutoHideControls();
      disableControls();

      _playerSettingsView && _playerSettingsView.close();
      hideControls(true, true);
      hideVideoAndShowClickToReplay();
   };

   var onVideoEnd = function() {
      _$container.trigger(events.Media.End);

      if (_mediaList.isPlaylist && !_mediaList.onLastMedia) {
         _viewDirty = true;
         _mediaList.currentMediaIndex = 'next';
         initCurrentMedia();
      } else {
         pause();

         endActionsController.executeEndAction(reshowVideoAfterClickToReplay, showReplayControlsHandler);

         if (playerConfiguration.getTrackEvents()) {
            processPlayerEvent('Video_Finished_Action', playerConfiguration.getEndActionParam());
         }
      }
   };

   var setupControls = function() {
      _mediaWrapper.on('ended', function() {
         if (getScrubbing()) {
            return;
         }

         onVideoTimeUpdate();

         if (playerConfiguration.getTrackEvents()) {
            if (playerConfiguration.getAltEventCategoryAsFilename()) {
               processPlayerEvent('Video_Finished', _eventCategory);
            } else {
               processPlayerEvent('Video_Finished', _mediaList.currentMedia.uri);
            }
         }
      });

      _mediaElement.addEventListener(events.Media.Play, resetPlayStartAnalytics);
      _mediaElement.addEventListener(events.Media.Play, hideClickToPlayControl);

      _$container.on(events.Controls.ClickPrev, function() {
         if (!_mediaList.onFirstMedia) {
            _mediaList.currentMediaIndex = 'previous';
            initCurrentMedia();
         }
      });

      _$container.on(events.Controls.ClickNext, function() {
         if (!_mediaList.onLastMedia) {
            _mediaList.currentMediaIndex = 'next';
            initCurrentMedia();
         }
      });

      _$container.on(events.Media.SeekToTime, function(e, time) {
         if (_controlsHidden) {
            showControlsWithAutoHide();
         }

         seek(time);
      });

      _$container.on(events.Scrubbing.Started, function() {
         blockTextSelection();
         disableAutoHideControls();
      });

      _$container.on(events.Scrubbing.Ended, function() {
         unblockTextSelection();
         resetHideControlsTimeout();
         enableAutoHideControls();
         onVideoTimeUpdate();
      });

      setupProgressBarAtPageLoad();

      var onTocItemClicked = function(timeToSeekTo, fileToSeekTo) {
         if (fileToSeekTo !== undefined) {
            var videoIndex = _mediaList.getMediaIndexByUri(fileToSeekTo);
            if (videoIndex === _mediaList.currentMediaIndex) {
               seek(timeToSeekTo);
            } else {
               _mediaList.currentMediaIndex = videoIndex;
               initCurrentMedia();
            }
         } else {
            seek(timeToSeekTo);
         }
      };

      var setupPlayerSettingsView = function(validRateSettings) {
         _playerSettingsView = PlayerSettingsView.create(_$container, _mediaElement, _xmp, validRateSettings);
         if (typeof _initializedValues.playbackRate !== 'undefined') {
            _playerSettingsView.playbackRate = _initializedValues.playbackRate;
         }
      };

      if (_haveYouTubePlayer) {
         if (youTube.player.supportPlaybackRate) {
            setupPlayerSettingsView(youTube.player.validRateSettings);
         } else {
            PlayerSettingsView.hideButton(_$container);
         }
      } else {
         setupPlayerSettingsView();
      }

      // sidebar stuff
      if (_displayToc) {
         _tocView = TocView.create(_$container, _xmp);

         _tocView.addEventListener('clickTocItem', onTocItemClicked);

         _$container.on(events.Controls.ShowToc, function() {
            showToc(true);
         });

         _$container.on(events.Controls.HideToc, function() {
            showToc(false);
         });
      }

      if (deviceInfo.getIOSSupportsInlineVideo() || deviceInfo.isAndroid()) {
         window.addEventListener('orientationchange', function() {
            if (_fullscreenControlView.isFullFrame) {
               // when keyboard is up on ipad, the size of screen
               // is reported wrong until we get rid of it
               if (_tocView && _tocView.searchIsFocused) {
                  _tocView.blurSearchInput();
                  setTimeout(resizeAfterOrientationChange, 500);
               } else {
                  resizeAfterOrientationChange();
               }
            }
         });
      }

      enableControls();

      if (isControlsHidden()) {
         hideControls(true, true);
      }
   };

   var replayVideo = function(time) {
      showControlsWithAutoHide();
      _playRewindControlsView && _playRewindControlsView.setInitialFocus();
      reshowVideoAfterClickToReplay(time, true);
      if (playerConfiguration.getTrackEvents()) {
         if (playerConfiguration.getAltEventCategoryAsFilename()) {
            processPlayerEvent('Video_Replay', _eventCategory);
         } else {
            processPlayerEvent('Video_Replay', _mediaList.currentMedia.uri);
         }
      }
   };

   var resizeAfterOrientationChange = function() {
      sizePageElements();
   };

   var showControlsWithoutAutoHide = function() {
      showControls(false);
   };

   var showControlsWithAutoHide = function() {
      showControls(true);
   };

   var onContainerClick = function() {
      _lastClickTime = new Date().getTime();
      showControlsWithAutoHide();
   };

   var onContainerLeave = function() {
      //Older Win touch devices emulate clicks with Enter -> Click -> Leave, so we need hax for them
      if (!_lastClickTime || new Date().getTime() - _lastClickTime > _surfaceClickLeaveDelay) {
         hideControlsOnTimeout();
      }
   };

   var onContainerMousemove = function(e) {
      var x = e.pageX;
      var y = e.pageY;

      if (!x && x !== 0 || !y && y !== 0) {
         //Just in case values aren't assigned for some reason
         showControlsWithAutoHide();
         return;
      }

      var deltaX = Math.abs(x - _lastMouseMoveCoords.x);
      var deltaY = Math.abs(y - _lastMouseMoveCoords.y);

      if (deltaX + deltaY > _mouseMoveTolerance) {
         _lastMouseMoveCoords.x = x;
         _lastMouseMoveCoords.y = y;
         showControlsWithAutoHide();
      }
   };

   var enableAutoHideControls = function() {
      if (_autoHideControlsEnabled || !playerConfiguration.getAutoHideControls() || _xmp && _xmp.hasCaptionItems && _xmp.captionPosition === 'under') {
         return false;
      }
      _autoHideControlsEnabled = true;

      _$container.on('mousemove', onContainerMousemove);
      _$container.on('keydown', showControlsWithAutoHide);
      _$container.on('click', onContainerClick);
      _$container.on('mouseleave', onContainerLeave);

      resetHideControlsTimeout();

      return true;
   };

   var disableAutoHideControls = function() {
      if (!_autoHideControlsEnabled) {
         return;
      }
      _autoHideControlsEnabled = false;
      clearHideControlsTimeout();
      _$container.off('mousemove', onContainerMousemove);
      _$container.off('keydown', showControlsWithAutoHide);
      _$container.off('click', onContainerClick);
      _$container.off('mouseleave', onContainerLeave);
   };

   var hideControlsOnTimeout = function(forceHide) {
      hideControls(forceHide, false);
      if (_controlsHidden) {
         _clickControls && _clickControls.disable();
      }
   };

   var hideControls = function(forceHide, hideElementAfterFadeOut) {
      var controlsAreBusy = getScrubbing() || _playerSettingsView && _playerSettingsView.isOpen;
      if (!forceHide && controlsAreBusy) {
         return;
      }

      _controlsHidden = true;
      _$controls.stop(true, true);
      _$controls.fadeTo(_animationSpeed, 0, function() {
         if (hideElementAfterFadeOut) {
            _$controls.hide();
         }
      });

      if (_tocView && _tocView.isOpen) {
         _tocView.hide(_animationSpeed);
      }

      _volumeControlView.hideControls();

      if (_haveYouTubePlayer && playerConfiguration.getDisableYouTubeControls()) {
         _$youtubePointerEventWorkaround.removeClass(cssClasses.hide);
      }
   };

   var showControls = function(onAutoHide) {
      if (isControlsHidden() || _mediaFailedToPlay) {
         return;
      }

      _$controls.show();

      if (_controlsHidden) {
         _controlsHidden = false;
         _$controls.stop(true, true);
         _$controls.fadeTo(_animationSpeed, 1);

         if (!_hotspotsView || !_hotspotsView.oneOrMoreHotspotsWithTimeActionArePaused) {
            if (deviceInfo.isTouchInterface()) {
               setTimeout(_clickControls.enable, _animationSpeed);
            } else {
               _clickControls.enable();
            }
         }

         if (_tocView && _tocView.isOpen) {
            _tocView.show(_animationSpeed);
         }

         if (_viewDirty) {
            _viewDirty = false;
            sizePageElements();
         }
      }

      if (onAutoHide) {
         resetHideControlsTimeout();
      }

      if (_haveYouTubePlayer) {
         _$youtubePointerEventWorkaround.addClass(cssClasses.hide);
      }
   };

   var clearHideControlsTimeout = function() {
      window.clearTimeout(_autoHideTimeoutId);
   };

   var resetHideControlsTimeout = function() {
      clearHideControlsTimeout();
      if (playerConfiguration.getAutoHideControls()) {
         _autoHideTimeoutId = window.setTimeout(hideControlsOnTimeout, _autoHideControllerTime);
      }
   };

   var disableOverlays = function() {
      _overlaysDisabled = true;
      _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
      _beforeAfterPlayControlsView.hideVideoClickToReplayLink();
   };

   var onCanPlayVideo = function() {
      if (videoAnalytics.isEnabled()) {
         videoAnalytics.setVideoLoadEndTime(new Date().getTime());

         if (playerConfiguration.getTrackEvents()) {
            if (playerConfiguration.getAltEventCategoryAsFilename()) {
               if (playerConfiguration.getAltLoadTimeAsSeconds()) {
                  processPlayerEvent('Video_Loading_Time_In_Seconds', _eventCategory, videoAnalytics.getVideoLoadTime() / 1000);
               } else {
                  processPlayerEvent('Video_Loading_Time', _eventCategory, videoAnalytics.getVideoLoadTime());
               }
            } else if (playerConfiguration.getAltLoadTimeAsSeconds()) {
               processPlayerEvent('Video_Loading_Time_In_Seconds', _mediaList.currentMedia.uri, videoAnalytics.getVideoLoadTime() / 1000);
            } else {
               processPlayerEvent('Video_Loading_Time', _mediaList.currentMedia.uri, videoAnalytics.getVideoLoadTime());
            }
         }
      }

      performanceWrapper.createMeasure(events.Timing.VideoCanPlay, events.Timing.VideoCanPlay);
      triggerRumDataEvent([events.Timing.VideoCanPlay]);

      _canPlayVideo = true;

      _mediaWrapper.off('canplay', onCanPlayVideo);
   };

   var onSeeking = function() {
      _seeking = true;
   };

   var onSeeked = function() {
      _seeking = false;
      if (_timeAfterSeek > -1) {
         seek(_timeAfterSeek);
         _timeAfterSeek = -1;
      }
   };

   var processScormInitialData = function() {
      videoAnalytics.populateVideoSegmentsWatch(scormController.initialVideoAnalyticsSnapshot);
      if (scormController.initialQuizModelSnapshot) {
         quizController.populateQuizModel(scormController.initialQuizModelSnapshot);
         _progressBarControlView.updateQuizMarkers();
      }

      // seek video to last stored time unless using the quiz service
      if (quizController.quizModel === null || quizController.quizModel.reportMethod === reportType.SCORM) {
         var seekTime = scormController.initialVideoTimeInSeconds;
         if (seekTime < _mediaElement.duration) {
            videoAnalytics.markTimeWatched(seekTime * 1000);
            seek(seekTime);
         }
      }
   };

   var onPlayingEvent = function() {
      _mediaWrapper.off('playing', onPlayingEvent);
      _ioOverlayView.hideView();

      if (!_mediaList.isPlaylist && playerConfiguration.isScormLesson) {
         processScormInitialData();
      }

      if (playerConfiguration.getJumpToTime()) {
         var timeToSeek = convertUrlTime(playerConfiguration.getJumpToTime());
         if (timeToSeek < _mediaElement.duration) {
            seek(Number(timeToSeek));
         }
      }

      // send a playing/streaming confirmation if applicable
      _playerViewEventCallbacks[events.External.VideoPlay].forEach(function(callback) {
         callback.call(_self);
      });
   };

   var onVolumeChanged = function() {
      _volumeControlView.onVolumeChanged();
   };

   var setupViews = function() {
      _captionsView = CaptionsView.create(_$container, _captionService);
      _tabController = TabController.create(_$container, _progressBarControlView.controlElement, _fullscreenControlView.controlElement);

      if (playerConfiguration.audioDescriptionMediaSrc) {
         _audioDescriptionControlView = AudioDescriptionControlView.create(_$container);
         _audioDescriptionTrackView = AudioDescriptionTrackView.create(_$container, _mediaElement, playerConfiguration.audioDescriptionMediaSrc);
      }
   };

   var setupXmpFeatures = function() {
      if (_xmp === null) {
         return;
      }

      if (_xmp.hasHotspotItems) {
         _hotspotsView = HotspotsView.create(_$container, _xmp, _mediaElement, _tabController);
         _$hotspotsContainer.replaceWith(_hotspotsView.$hotspots);
      }

      if (_xmp.hasCaptionItems) {
         _captionService.initFromXmp(_xmp);
         _captionsView.handleDisplayCaptions();
      }
   };

   var getHtmlForPlayer = function(mediaSources, includeControls, includePosterIfAvailable) {
      if (!includePosterIfAvailable) {
         includePosterIfAvailable = false;
      }

      var html = '<video';

      if (includePosterIfAvailable && playerConfiguration.getPosterImageSrc()) {
         html += ' poster="' + playerConfiguration.getPosterImageSrc() + '"';
      }

      if (includeControls) {
         html += ' controls';
      }

      if (deviceInfo.getIOSSupportsInlineVideo()) {
         html += ' webkit-playsinline playsinline';
      }

      html += '>';

      var numberMediaSource = mediaSources.length;
      for (var i = 0; i < numberMediaSource; i++) {
         var source = playerConfiguration.getUnicodeSafeString(mediaSources[i].media);
         html += '<source src="' + source + '" type="' + mediaSources[i].mimeType + '" />';
      }
      html += playerConfiguration.getUnableToDisplayContentString() + '</video>';

      return html;
   };

   var showVideoLoadingMessage = function() {
      if (!_haveYouTubePlayer) {
         _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
         _ioOverlayView.displayMessage(_lang.strings.videoLoading);
      }
   };

   var getVideoElement = function() {
      if (_haveYouTubePlayer) {
         return youTube.player;
      }
      return $('video')[0];
   };

   var handleFirstPlay = function() {
      if (quizController.hasQuiz && quizController.quizEnabled) {
         initQuiz();
      } else {
         initUI();
      }
   };

   var initQuiz = function() {
      _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
      quizController.init(_$container, playerConfiguration.getEnforceLinearAssessment(), getVideoElement);
   };

   var onYouTubeError = function(event) {
      MessageBarView.create(_$container, messageBarType.info, event.data);
   };

   var initMediaPlugins = function() {
      var pluginController = playerConfiguration.getPluginController();
      if (!pluginController) {
         return;
      }
      _$mediaPluginContainer.show();
      pluginController.initializePluginsForViewElement(supportedPluginViewElements.MEDIA, _$mediaPluginContainer);
   };

   var onLoadStart = function() {
      performanceWrapper.createMarker(events.Timing.VideoMetadataLoaded);
      performanceWrapper.createMarker(events.Timing.VideoLoadedData);
      performanceWrapper.createMarker(events.Timing.VideoCanPlay);
   };

   var onLoadedData = function() {
      performanceWrapper.createMeasure(events.Timing.VideoLoadedData, events.Timing.VideoLoadedData);
      triggerRumDataEvent([events.Timing.VideoLoadedData]);
   };

   var initUI = function() {
      // this prevents double-click on click-to-play
      if (_uiInitialized) {
         return;
      }

      showVideoLoadingMessage();

      _uiInitialized = true;

      if (_haveYouTubePlayer) {
         _mediaWrapper = youTube.player;
         _mediaElement = youTube.player;
      } else if (_mediaList.isTscProj) {
         _mediaWrapper = _renderLibView;
         _mediaElement = _renderLibView.view;
      } else {
         var html = getHtmlForPlayer(_mediaList.mediaList, false);
         $('.video-div').html(html);

         _mediaWrapper = $(_containerSelector + ' video');
         if (_mediaWrapper.length > 0) {
            _mediaElement = _mediaWrapper[0];
         }
      }

      _playRewindControlsView = PlayRewindControlsView.create(_$container, _mediaElement);
      _prevNextControlsView = PrevNextControlsView.create(_$container);
      _progressBarControlView = ProgressBarControlView.create(_$container, _mediaElement, quizController.quizModel);
      _volumeControlView = VolumeControlView.create(_$container, _mediaElement);
      _pipControlView = PipControlView.create(_$container, _mediaElement);
      _fullscreenControlView = FullscreenControlView.create(_$container);
      _clickControls = ClickControlsView.create(_$container, _mediaElement, _fullscreenControlView, _progressBarControlView, youTube);
      if (typeof _initializedValues.muted !== 'undefined') {
         _volumeControlView.muted = _initializedValues.muted;
      }
      if (typeof _initializedValues.volume !== 'undefined') {
         _volumeControlView.volume = _initializedValues.volume;
      }

      if (!_mediaList.isPlaylist) {
         _prevNextControlsView.hide();
      } else {
         _prevNextControlsView.show();
      }

      processQueuedMediaBinds();

      // dispatch callback for media started event (note: after _mediaWrapper and _mediaElement are set)
      _playerViewEventCallbacks[events.External.VideoStart].forEach(function(callback) {
         callback.call(_self);
      });

      var eventsToBind = {};
      if (_mediaList.isTscProj) {
         eventsToBind = {
            playing: onPlayingEvent,
            seeking: onSeeking,
            seeked: onSeeked,
            timeupdate: onVideoTimeUpdate,
            progress: updateBuffered,
            volumechange: onVolumeChanged
         };
      } else {
         eventsToBind = {
            loadstart: onLoadStart,
            loadedmetadata: onLoadedMetadata,
            loadeddata: onLoadedData,
            playing: onPlayingEvent,
            canplay: onCanPlayVideo,
            seeking: onSeeking,
            seeked: onSeeked,
            timeupdate: onVideoTimeUpdate,
            progress: updateBuffered,
            volumechange: onVolumeChanged
         };
      }

      _mediaWrapper.on(eventsToBind);
      _$videoWrapper.removeClass(cssClasses.hide);

      _$container.on(events.Captions.Changed, processCaptionChanged);
      _$container.on(events.Plugin.Added, initMediaPlugins);

      setupViews();
      setupXmpFeatures();
      initMediaPlugins();
      setupControls();
      _viewDirty = true;
      sizePageElements();

      // hide controls and show message while we wait for video to do initial load
      _$controls.hide();

      if (_mediaWrapper.metadataReady) {
         _mediaWrapper.metadataReady.then(function() {
            _$controls.show();
            onLoadedMetadata();
            return _mediaWrapper.canPlayReady.then(function() {
               onCanPlayVideo();
               initCurrentMedia();
            });
         });
      } else {
         initCurrentMedia();
      }
   };

   var videoNotFoundError = function() {
      _beforeAfterPlayControlsView.setVideoClickToPlayErrorState(true);
      _ioOverlayView.displayMessage(_lang.strings.mediaNotFound, true);

      // If the video somehow loads after the error is displayed, get rid of the error screen.
      _mediaWrapper.on('timeupdate', function(event) {
         if (_mediaElement.buffered.length !== 0) {
            _beforeAfterPlayControlsView.setVideoClickToPlayErrorState(false);
            _ioOverlayView.hideView();
            $(this).off(event);
         }
      });
   };

   var initCurrentMedia = function() {
      var clearVideoTimeout;
      // Safari 8 has a bug that prevents it from throwing errors on 404 video content,
      // so instead we'll give it x seconds to load something or error out.
      if (deviceInfo.isSafari() && deviceInfo.getSafariMajorVersion() === '8') {
         clearVideoTimeout = window.setTimeout(function() {
            if (_mediaElement.buffered.length === 0) {
               videoNotFoundError();
            }
         }, _loadVideoTimeout);
      }

      // Selecting video and sources because ie throws errors to video and everyone to sources
      $('video, video source').off('error').on('error', function() {
         if (quizController && quizController.viewIsOpen) {
            // HAX to fix busted state that happens sometimes in IE when you scroll to a quiz marker
            setTimeout(function() {
               play();
               if (_lastQuestionSetMarkerTime || _lastQuestionSetMarkerTime === 0) {
                  seek(_lastQuestionSetMarkerTime);
               }
               pause();
            }, 300);

            return;
         }

         clearTimeout(clearVideoTimeout);
         videoNotFoundError();
      });

      _processingEndOfVideo = false;
      if (_mediaList.isPlaylist) {
         if (_mediaList.onFirstMedia) {
            _prevNextControlsView.disablePreviousButton();
         } else {
            _prevNextControlsView.enablePreviousButton();
         }

         if (_mediaList.onLastMedia) {
            _prevNextControlsView.disableNextButton();
         } else {
            _prevNextControlsView.enableNextButton();
         }

         if (videoAnalytics.isEnabled()) {
            videoAnalytics.clearPercentWatched();
            _eventLastPercentReported = 0;
         }

         _mediaElement.src = _mediaList.currentMedia.media;

         if (_progressBarControlView) {
            _progressBarControlView.durationHasChanged();
         }
      }

      if (_startPlaybackOnInit) {
         play();

         // OSX Safari on some machines fast forwards videos when we call play with a quiz at frame 0.
         // Resetting the current time resolves this behavior. Ref https://github.com/TechSmith/SmartPlayer/issues/387
         if (deviceInfo.isSafari() && !deviceInfo.isIOS() && _mediaElement.readyState === 0) {
            _mediaElement.addEventListener('canplay', function resetTime() {
               _mediaElement.currentTime = 0;
               _mediaElement.removeEventListener('canplay', resetTime);
            });
         }
      }
   };

   var hideClickToPlayControl = function() {
      _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
   };

   var resetPlayStartAnalytics = function() {
      if (videoAnalytics.isEnabled()) {
         videoAnalytics.setVideoLoadStartTime(new Date().getTime());
      }

      if (playerConfiguration.getTrackEvents() && _eventPlayTracking) {
         _eventPlayTracking = false;
         if (playerConfiguration.getAltEventCategoryAsFilename()) {
            processPlayerEvent('Video_Started', _eventCategory);
         } else {
            processPlayerEvent('Video_Started', _mediaList.currentMedia.uri);
         }
         processPlayerEvent('Video_Percent_Viewed', 'Viewed: 0 Percent');
      }
   };

   var quizEventHandler = function(event, data) {
      switch (event.type) {
         case events.Quizzing.Complete:
         case events.Quizzing.Review:
            if (_processingEndOfVideo) {
               return;
            }

            if (_tocView && _tocView.isOpen) {
               _tocView.show(_animationSpeed);
            }

            enableControls();
            viewHelper.focusPreviousElement();

            enableAutoHideControls();

            _progressBarControlView.updateQuizMarkers();

            if (event.type === events.Quizzing.Review && playerConfiguration.getEnforceLinearAssessment()) {
               var prevMarkerTime = quizController.findPrevMarkerTimeForMarker(_lastQuestionSetId);
               _lastQuestionSetId = -1;
               seek(prevMarkerTime / 1000);
               play();
            } else {
               play();
            }
            break;
         case events.Quizzing.SubmittingInstance:
            showVideoLoadingMessage();
            break;
         case events.Quizzing.Begin:
         case events.Quizzing.Skip:
            if (!_mediaWrapper) {
               initUI();
            } else if (_videoMetadataReady && quizController.quizReady) {
               onVideoReady();
               if (_startPlaybackOnInit) {
                  play();
               }
               _viewDirty = true;
               sizePageElements();
            }

            quizController.startTrackingProgress();

            break;
         case events.Quizzing.Error:
            if (!_mediaWrapper) {
               initUI();
            }

            MessageBarView.create(_$container, messageBarType.info, localizationStrings.strings.txtVideoQuizNetworkErrorMessage, localizationStrings.strings.close);
            break;
         case events.Quizzing.Status:
            _ioOverlayView.displayMessage(data.message);
            break;
         case events.Quizzing.HideLoadingMessage:
         case events.Quizzing.Submitted:
            _ioOverlayView && _ioOverlayView.hideView();
            break;
         case events.Quizzing.RationaleActionJumpToTime:
            var jumpToTimeInSeconds = data.jumpToTime / 1000;
            _progressBarControlView.allowSkipQuestionSetMarkersBeforeTime(jumpToTimeInSeconds);
            safeSeek(jumpToTimeInSeconds);
            break;
      }
   };

   var preventEvent = function(e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
   };

   var onLoadAndPlayControlEvent = function() {
      _playerViewEventCallbacks[events.External.VideoStartInitiated].forEach(function(callback) {
         callback.call(_self);
      });

      showVideoLoadingMessage();

      var onPlaybackReady = function() {
         if (quizController.hasQuiz && quizController.quizEnabled) {
            initQuiz();
         } else {
            initUI();
         }
      };

      if (_haveYouTubePlayer) {
         youTube.playbackReadyPromise.then(onPlaybackReady);
      } else {
         onPlaybackReady();
      }
   };

   var onPlayControlEvent = function() {
      _mediaFailedToPlay = false;
      showControls(true);
      enableAutoHideControls();
      play();

      // need to handle jump to time
      if (playerConfiguration.jumpToTime) {
         var timeToSeek = convertUrlTime(playerConfiguration.jumpToTime);
         if (timeToSeek < _mediaElement.duration) {
            seek(Number(timeToSeek));
         }
      }
   };

   var initDomForHTML5 = function(containerSelector, displayToc) {
      _containerSelector = containerSelector;
      _containerIDString = _containerSelector.replace(/^[#]/, '');
      _videoTagUniqueId = [_containerIDString, 'video-div'].join('-');
      _displayToc = displayToc;

      // need this before setting vars proceeding
      var html5VideoMarkup = templates.html5_player_template({
         videoTagUniqueId: _videoTagUniqueId,
         videoWrapperIndex: tabIndex.VideoWrapper
      });

      _$container.html(html5VideoMarkup);

      _$controls = _$container.find('#controls');
      _$hotspotsContainer = _$container.find('.hotspots-container');
      _$mediaPluginContainer = _$container.find('.media-plugin-container');
      _$mediaPluginContainer.hide();
      _$videoWrapper = _$container.find('.video-wrapper');
      _$videoDiv = _$container.find('.video-div');
      _$youtubePointerEventWorkaround = _$container.find('.youtube-pointer-event-workaround');

      _beforeAfterPlayControlsView = BeforeAfterPlayControlsView.create(_$container);
      _ioOverlayView = IoOverlayView.create(_$container);
      if (_haveYouTubePlayer) {
         setupHeadlessMode();
      }

      _$container.css('background-color', playerConfiguration.getBackgroundColor());

      if (playerConfiguration.getPosterImageSrc() && !_haveYouTubePlayer) {
         _beforeAfterPlayControlsView.addVideoClickToPlayBackground(playerConfiguration.getPosterImageSrc());
      }

      _$container.on('mousedown', '*', function() {
         highlightDisabler.disableHighlights($(this));
      });

      _$container.on(events.Controls.LoadAndPlayControl, onLoadAndPlayControlEvent);
      _$container.on(events.Controls.PlayControl, onPlayControlEvent);

      if (playerConfiguration.getDisableContextMenuForVideo()) {
         _$videoDiv.on('contextmenu', preventEvent);
      }

      if (quizController.hasQuiz && quizController.quizEnabled) {
         quizController.setViewControlBarOffset(_controlBarHeight);
         quizController.setViewContainer(_$videoWrapper);
         _$container.on(events.Quizzing.Complete, quizEventHandler);
         _$container.on(events.Quizzing.Review, quizEventHandler);
         _$container.on(events.Quizzing.Begin, quizEventHandler);
         _$container.on(events.Quizzing.Skip, quizEventHandler);
         _$container.on(events.Quizzing.Error, quizEventHandler);
         _$container.on(events.Quizzing.Status, quizEventHandler);
         _$container.on(events.Quizzing.SubmittingInstance, quizEventHandler);
         _$container.on(events.Quizzing.Submitted, quizEventHandler);
         _$container.on(events.Quizzing.RationaleActionJumpToTime, quizEventHandler);
         _$container.on(events.Quizzing.HideLoadingMessage, quizEventHandler);
      }

      _$container.fadeIn(_animationSpeed);

      sizePageElements();

      _$container.resize(function() {
         _viewDirty = true;
         sizePageElements();
      });

      responsiveController.monitorContainerSize(_$container);
   };

   // TODO: setup in this function probably isn't the responsibility of the 'view' when we untangle this mess, but for now it is coupled
   var setupServices = function(captionsService) {
      _captionService = captionsService;
   };

   var setupHeadlessMode = function() {
      disableOverlays();
      _startPlaybackOnInit = false;
      _playerViewEventCallbacks[events.External.VideoStartInitiated].forEach(function(callback) {
         callback.call(_self);
      });
   };

   var triggerRumDataEvent = function(timingMeasureList) {
      var eventData = {
         rum: performanceWrapper.getRumEventData(timingMeasureList)
      };

      _playerViewEventCallbacks[events.External.PlayerRumData].forEach(function(callback) {
         callback.call(_self, eventData);
      });
   };

   var initHTML5 = function() {
      // ignore auto play if this is an iOS device that plays video inline or there is a quiz present
      // may want to move this out of the view at some point.
      if ((deviceInfo.getIOSSupportsInlineVideo() || deviceInfo.isAndroid() || quizController.hasQuiz && quizController.quizEnabled) && !playerConfiguration.getMobileWebViewCanAutoPlay()) {
         playerConfiguration.setAutoPlayMedia(false);
      }

      if (playerConfiguration.getAutoPlayMedia() === true && playerConfiguration.getJumpToTime() === undefined) {
         showVideoLoadingMessage();
         _playerViewEventCallbacks[events.External.VideoStartInitiated].forEach(function(callback) {
            callback.call(_self);
         });
         setTimeout(initUI, 80);
      } else if (playerConfiguration.getPreload() === 'metadata') {
         setupHeadlessMode();
         setTimeout(initUI, 80);
      }

      if (_haveYouTubePlayer) {
         _ioOverlayView.hideView();
      }

      _$container.on(events.Media.Replay, function() {
         replayVideo(0);
      });

      ieFullscreenDimensionsFix.initialize(_$container);

      // quiz
      if (quizController.hasQuiz && quizController.quizEnabled) {
         quizController.setViewControlBarOffset(_controlBarHeight);
         quizController.setViewContainer(_$videoWrapper);
         if (playerConfiguration.getJumpToTime() !== undefined || _overlaysDisabled) {
            setTimeout(initQuiz, 80);
         }
      } else if (playerConfiguration.getJumpToTime() !== undefined) {
         showVideoLoadingMessage();
         setTimeout(initUI, 80);
      }

      // turn on video analytics when using Google Analytics, Scorm or Quiz
      if (!_mediaList.isPlaylist && (playerConfiguration.getTrackEvents() || playerConfiguration.isScormLesson || playerConfiguration.getReportScormComplete() || quizController.hasQuiz && quizController.quizEnabled)) {
         videoAnalytics.setEnabled(true);
      }

      _html5ViewEnabled = true;

      performanceWrapper.createMeasure(events.Timing.PlayerLoaded, events.Timing.PlayerLoaded);
      performanceWrapper.createMeasure(events.Timing.PlayerInitialized, events.Timing.PlayerInitialized);

      triggerRumDataEvent([events.Timing.PlayerLoaded, events.Timing.PlayerInitialized]);
   };

   var processCaptionChanged = function(e, eventData) {
      if (eventData) {
         _playerViewEventCallbacks[events.External.CaptionChange].forEach(function(callback) {
            callback.call(_self, eventData.plainText);
         });
      }
   };

   var processHotspotClick = function(e, eventData) {
      if (eventData.jumpFile !== undefined) {
         _mediaList.currentMediaIndex = _mediaList.getMediaIndexByUri(eventData.jumpFile);
         initCurrentMedia();
      } else if (eventData.jumpTime !== undefined && eventData.jumpTime !== '') {
         safeSeek(Number(eventData.jumpTime) / 1000);
         play();
      } else if (eventData.location !== undefined && eventData.location !== '') {
         if (playerConfiguration.getTrackEvents()) {
            processPlayerEvent('Hotspot_Action', eventData.location);
         }
         var targetWindow = '_parent';
         if (eventData.newWindow !== undefined && eventData.newWindow === true) {
            targetWindow = '_blank';
         }
         urlService.openUrl(eventData.location, targetWindow);
      } else {
         play();
      }
   };

   var convertUrlTime = function(val) {
      if (isNaN(val)) {
         var hrs = 0;
         var min = 0;
         var sec = 0;
         var strTime = val.toLowerCase();
         // Regex patterns ----------------------------------------------------
         var hrsPattern = new RegExp('(\\d+[\h])', 'g'); //( 999h )
         var minPattern = new RegExp('(\\d+[\m])', 'g'); //( 999m )
         var secPattern = new RegExp('(\\d+[\s])', 'g'); //( 999s )
         var numPattern = new RegExp('\\d+', 'g'); // * numerals
         // Match regex Tests -------------------------------------------------
         var hrsTest = strTime.match(hrsPattern);
         var minTest = strTime.match(minPattern);
         var secTest = strTime.match(secPattern);
         var numTest = strTime.match(numPattern);

         if (secTest || minTest || hrsTest) {
            // assumes we want the 1st pattern encountered in each array is
            // the time we want to use.

            if (hrsTest) {
               // 3600 seconds in 1 hour
               hrs = Number(hrsTest[0].split('h').join('')) * 60 * 60;
            }

            if (minTest) {
               // 60 seconds in 1 minute
               min = Number(minTest[0].split('m').join('')) * 60;
            }

            if (secTest) {
               // 1 seconds = 1 second
               sec = Number(secTest[0].split('s').join(''));
            }
            // return the Time in seconds
            return Number(hrs + min + sec);
         } else if (numTest) {
            sec = Number(numTest[0]);
               // return the Time assuming seconds
            return sec;
         }
               // not valid time or all non-numeric characters
         return 0;
      }
      if (val < 0) {
         val = 0;
      }

      return val;
   };

   var addMediaEventListener = function(event, handler) {
      if (_mediaWrapper) {
         _mediaWrapper.on(event, handler);
      } else {
         if (typeof _queuedMediaBinds[event] !== 'object') {
            _queuedMediaBinds[event] = [];
         }
         _queuedMediaBinds[event].push(handler);
      }
   };

   var removeMediaEventListener = function(event, handler) {
      if (_mediaWrapper) {
         _mediaWrapper.off(event, handler);
      } else {
         if (typeof _queuedMediaBinds[event] !== 'object') {
            return;
         }
         // if the same handler is bound multiple times?
         while (_queuedMediaBinds[event].indexOf(handler) !== -1) {
            _queuedMediaBinds[event].splice(_queuedMediaBinds[event].indexOf(handler), 1);
         }
      }
   };

   var processQueuedMediaBinds = function() {
      Object.keys(_queuedMediaBinds).forEach(function(event) {
         if (typeof _queuedMediaBinds[event] === 'object') {
            _queuedMediaBinds[event].forEach(function(callback) {
               _mediaWrapper.on(event, callback);
            });
         }
      });
      _queuedMediaBinds = {};
   };

   var isYouTube = function() {
      return _haveYouTubePlayer;
   };

   var getCaptionCollection = function() {
      return _captionService.captionTrack.captionCollection;
   };

   var getCaptionTrack = function() {
      return _captionService.captionTrack;
   };

   var setCaptionTrack = function(value) {
      _captionService.captionTrack = value;
      if (_captionsView) {
         _captionsView.handleDisplayCaptions();
      }
   };

   var getCaptionsVisible = function() {
      return _captionsView ? _captionsView.visible : playerConfiguration.getCaptionsEnabled();
   };

   var setCaptionsVisible = function(value) {
      if (_captionsView) {
         _captionsView.visible = value;
         _captionsView.handleDisplayCaptions();
         updateCaptions();
      } else {
         playerConfiguration.setCaptionsEnabled(value);
      }
   };

   var setupExternalEventCallbackHarness = function() {
      Object.keys(events.External).forEach(function(eventKey) {
         var eventName = events.External[eventKey];
         _playerViewEventCallbacks[eventName] = [];
      });
   };

   var externalEventIsSupported = function(eventName) {
      return Object.keys(events.External).some(function(eventKey) {
         return events.External[eventKey] === eventName;
      });
   };

   var destroy = function() {
      if (_$container) {
         _$container.off();
      }
      if (_mediaWrapper) {
         _mediaWrapper.off();
      }
      if (_$videoDiv) {
         _$videoDiv.off('contextmenu', preventEvent);
      }
      if (_progressBarControlView) {
         _progressBarControlView.destroy();
      }
      if (_volumeControlView) {
         _volumeControlView.destroy();
      }
      if (_tocView) {
         _tocView.destroy();
      }
      if (_audioDescriptionControlView) {
         _audioDescriptionControlView.destroy();
      }
      if (_audioDescriptionTrackView) {
         _audioDescriptionTrackView.destroy();
      }
      if (_captionsView) {
         _captionsView.destroy();
      }
      if (_beforeAfterPlayControlsView) {
         _beforeAfterPlayControlsView.destroy();
      }
      if (_playerSettingsView) {
         _playerSettingsView.destroy();
      }
      if (_pipControlView) {
         _pipControlView.destroy();
      }
      if (_tabController) {
         _tabController.destroy();
      }

      quizController.reset();

      clearHideControlsTimeout();
      responsiveController.forgetContainerSize(_$container);

      _$container = null;
      _containerSelector = null;
      _containerIDString = null;
      _videoTagUniqueId = null;

      _html5ViewEnabled = false;
      _mediaList = null;
      _playerViewEventCallbacks = {};
      _queuedMediaBinds = {};
      _initializedValues = {};
      _captionService = null;
      _mediaWrapper = null;
      _mediaElement = null;
      _$videoWrapper = null;
      _$videoDiv = null;
      _$controls = null;
      _$hotspotsContainer = null;
      _$youtubePointerEventWorkaround = null;
      _renderLibView = null;
      _tocView = null;
      _audioDescriptionControlView = null;
      _audioDescriptionTrackView = null;
      _captionsView = null;
      _hotspotsView = null;
      _beforeAfterPlayControlsView = null;
      _playRewindControlsView = null;
      _prevNextControlsView = null;
      _progressBarControlView = null;
      _volumeControlView = null;
      _playerSettingsView = null;
      _fullscreenControlView = null;
      _ioOverlayView = null;
      _clickControls = null;
      _intrinsicWidth = -1;
      _intrinsicHeight = -1;
      _currentTime = 0;
      _currentTimeInMilliseconds = 0;
      _timeAfterSeek = -1;
      _updateBufferedTimeout = null;
      _lastClickTime = null;
      _surfaceClickLeaveDelay = 100;
      _mouseMoveTolerance = 5;
      _lastMouseMoveCoords = {
         x: 0,
         y: 0
      };
      _xmp = null;
      _autoHideTimeoutId = -1;
      _autoHideControllerTime = 5000;
      _lastQuestionSetId = -1;
      _lastQuestionSetMarkerTime = -1;
      _eventLastPercentReported = 0;
      _eventPercentWatchInc = 10;
      _canPlayVideo = false;
      _viewDirty = false;
      _seeking = false;
      _displayToc = false;
      _controlsHidden = false;
      _videoMetadataReady = false;
      _processingEndOfVideo = false;
      _atVideoEndTime = false;
      _eventPlayTracking = true;
      _eventCategory = 'HTML5-Video';
      _haveYouTubePlayer = false;
      _loadVideoTimeout = 10000;
      _overlaysDisabled = false;
      _startPlaybackOnInit = true;
      _uiInitialized = false;
      _autoHideControlsEnabled = false;
      _playerInitializedAfterMetadataLoaded = false;

      setupExternalEventCallbackHarness();
   };

   setupExternalEventCallbackHarness();

   return {
      setupServices: setupServices,
      initHtml5View: function(containerSelector, displaySidebar, mediaList, xmpModel) {
         _mediaList = mediaList;
         _xmp = xmpModel;
         _$container = $(containerSelector);

         initDomForHTML5(containerSelector, displaySidebar);
         initHTML5();
         processPlayerEvent('Content_Loaded', _eventCategory, mediaList.currentMedia.uri);
      },
      initTscProjView: function(containerElement, displaySidebar, mediaList, xmpModel) {
         _mediaList = mediaList;
         _xmp = xmpModel;
         _$container = $(containerElement);

         var mediaLib = _mediaList.currentMedia.media;
         initDomForHTML5(containerElement, displaySidebar);

         _renderLibView = RenderLibView.create(mediaLib.model, mediaLib.theme);
         _renderLibView.ready.then(function() {
            _$videoDiv.append(_renderLibView.element);
            initHTML5();
         });
      },
      initYouTubeView: function(containerElement, displaySidebar, mediaList, xmpModel) {
         _mediaList = mediaList;
         _xmp = xmpModel;
         _$container = $(containerElement);

         var srcForMedia = _mediaList.currentMedia.media;

         _haveYouTubePlayer = true;
         initDomForHTML5(containerElement, displaySidebar);

         var startTime = playerConfiguration.getJumpToTime();
         if (startTime !== undefined) {
            startTime = convertUrlTime(startTime);
         } else {
            startTime = 0;
         }

         if (isControlsHidden()) {
            // Quiz location logic needs the controls to have reasonable width and height.
            // But in the case when we are using YouTube controls we want the controls hidden
            // so they can't be interacted with. By pushing it behind the player with z-index
            // it accomplishes "hiding" the controls but still allowing the controls to take
            // up the correct width and height for the quiz marker location logic. Using
            // _$controls.hide() does not accomplish the same affect and that is why it is
            // avoided here.
            _$controls.css('z-index', '-1');
         } else {
            _$videoWrapper.css('height', 'calc(100% - ' + _$controls.height() + 'px)');
         }

         youTube.init(srcForMedia, _videoTagUniqueId, initHTML5, handleFirstPlay, onYouTubeError, _$container.width(), _$container.height(), startTime);
         processPlayerEvent('Content_Loaded', _eventCategory, _mediaList.currentMedia.uri);
      },
      destroy: destroy,
      jsSeekTime: function(time) {
         if (_html5ViewEnabled) {
            if (_mediaWrapper) {
               if (_mediaElement.duration && time < _mediaElement.duration) {
                  // replay video when video is at the end
                  if (_atVideoEndTime) {
                     replayVideo(time);
                     // seek only when a quiz view isn't being shown
                  } else if (!quizController.hasQuiz || quizController.hasQuiz && !quizController.viewIsOpen) {
                     seek(time);
                  }
               }
            } else {
               playerConfiguration.jumpToTime = time;
               if (quizController.hasQuiz && quizController.quizEnabled) {
                  if (!quizController.viewIsOpen) {
                     setTimeout(initQuiz, 80);
                  }
               } else {
                  setTimeout(initUI, 80);
               }
            }
         }
      },
      jsPlay: function() {
         if (_html5ViewEnabled) {
            if (_mediaWrapper) {
               // replay video when video is at the end
               if (_atVideoEndTime) {
                  replayVideo(0);
                  // seek only when a quiz view isn't being shown
               } else {
                  play();
               }
            } else if (quizController.hasQuiz && quizController.quizEnabled) {
               if (!quizController.viewIsOpen) {
                  setTimeout(initQuiz, 80);
               }
            } else {
               setTimeout(initUI, 80);
            }
         }
      },
      // html5 element methods
      play: play,
      pause: pause,
      getCurrentSrc: function() {
         return _mediaElement !== null && _mediaElement.currentSrc !== undefined ? _mediaElement.currentSrc : playerConfiguration.getMediaSrc();
      },
      getCurrentTime: function() {
         return _mediaElement !== null ? _mediaElement.currentTime : 0;
      },
      getDuration: function() {
         return _mediaElement !== null ? _mediaElement.duration : 0;
      },
      getEnded: function() {
         return _mediaElement !== null ? _mediaElement.ended : false;
      },
      getMuted: function() {
         return _volumeControlView !== null ? _volumeControlView.muted : false;
      },
      getPaused: function() {
         return _mediaElement !== null ? _mediaElement.paused : false;
      },
      getPlaybackRate: function() {
         return _playerSettingsView ? _playerSettingsView.playbackRate : 1;
      },
      getBuffered: function() {
         return _mediaElement !== null ? _mediaElement.buffered : [];
      },
      getPlayed: function() {
         return _mediaElement !== null ? _mediaElement.played : [];
      },
      getSeekable: function() {
         return _mediaElement !== null ? _mediaElement.seekable : [];
      },
      getSeeking: function() {
         return _seeking;
      },
      getVolume: function() {
         return _volumeControlView !== null ? _volumeControlView.volume : 0;
      },
      setCurrentTime: safeSeek,
      setMuted: function(value) {
         if (_volumeControlView) {
            _volumeControlView.muted = value;
         } else {
            _initializedValues.muted = value;
         }
      },
      setPlaybackRate: function(value) {
         if (_playerSettingsView) {
            _playerSettingsView.playbackRate = value;
         } else {
            _initializedValues.playbackRate = value;
         }
      },
      setVolume: function(value) {
         if (_volumeControlView) {
            _volumeControlView.volume = value;
         } else {
            _initializedValues.volume = value;
         }
      },
      // end html5 element functions
      isInFullScreenMode: function() {
         if (_fullscreenControlView) {
            return _fullscreenControlView.isFullScreen;
         }
         return false;
      },
      addEventListener: function(type, listener) {
         if (externalEventIsSupported(type)) {
            _playerViewEventCallbacks[type].push(listener);
         }
      },
      removeEventListener: function(type, listener) {
         if (externalEventIsSupported(type)) {
            // just in case the same listener pointer is bound more than once?
            while (_playerViewEventCallbacks[type].indexOf(listener) !== -1) {
               _playerViewEventCallbacks[type].splice(_playerViewEventCallbacks[type].indexOf(listener), 1);
            }
         }
      },
      addMediaEventListener: addMediaEventListener,
      removeMediaEventListener: removeMediaEventListener,
      // html5 extended
      getIsYouTube: isYouTube,
      getScrubbing: getScrubbing,
      setScrubbing: setScrubbing,
      getCaptionCollection: getCaptionCollection,
      getCaptionTrack: getCaptionTrack,
      setCaptionTrack: setCaptionTrack,
      getCaptionsVisible: getCaptionsVisible,
      setCaptionsVisible: setCaptionsVisible
   };
});

